import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EssentialService } from '../../services/essential.service';
import { Subscription } from 'rxjs';
import { MenuService } from '../../services/menu.service';


declare const $: any;
@Component({
  selector: 'app-childs-menus',
  styleUrls: ['./header.component.css'],
  template: '',
  providers: [MenuService]
})
export class ChildsMenusComponent implements OnInit {
  @Input() parentId: number;
  @Input() settings: any;

  constructor(
    public menuService: MenuService,
    private router: Router) { }

  ngOnInit() {
  }

  public navigateTo(slug, el) {
    if (!el) {
      this.router.navigate([slug]);
    }
    if (el && slug) {
      this.router.navigate([slug]);
      setTimeout(() => {
        const elmnt = document.getElementById(el);
        if (elmnt && elmnt != null) {
          elmnt.scrollIntoView();
        }
      }, 200);
    }

  }
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
  // providers: [MenuService]
})

export class HeaderComponent implements OnInit {

  @Input() public settings: any;
  @Input() public blocks: any;
  @Input() public data: any;
  @Input() public selectedBlock: any = {};
  public allPages: any[] = [];
  public height: number;
  public userInfoSubscription: Subscription;
  public menus: any[];
  public searchText: any;
  public site: any;
  public user: any;
  public title: string;
  menuContentTheme = 'all';
  constructor(
    private router: Router, private route: ActivatedRoute, public menuService: MenuService,
    private essentialsService: EssentialService,
  ) {

  }

  public ngOnInit() {
    this.site = this.data.moduleService.site;
    this.GetCategoryMenus(this.settings.selectedCategory);
    this.GetAllPages();
    if (this.data.authService && this.data.authService.isLoggedIn()) {
      this.user = this.data.authService.getLoggedUser();
    }

    this.settings.nav_background_color = this.settings.nav_background_color && this.settings.nav_background_color.charAt(0) === '#' ? this.settings.nav_background_color : this.getThemeColor(this.settings.nav_background_color);
    this.settings.nav_text_color = this.settings.nav_text_color && this.settings.nav_text_color.charAt(0) === '#' ? this.settings.nav_text_color : this.getThemeColor(this.settings.nav_text_color);
    this.settings.child_background_color = this.settings.child_background_color && this.settings.child_background_color.charAt(0) === '#' ? this.settings.child_background_color : this.getThemeColor(this.settings.child_background_color);
    this.settings.child_text_color = this.settings.child_text_color && this.settings.child_text_color.charAt(0) === '#' ? this.settings.child_text_color : this.getThemeColor(this.settings.child_text_color);
    this.settings.blocks.forEach(element => {
      if (element.element.type == 'menu') {
        this.menuContentTheme = this.settings.menuTheme || 'all';
        let slug = this.route.data['value'].data[0].slug;
        this.menuService.getMenu(element.menuCat, this.data, slug);

        this.route.paramMap.subscribe(
          route => {
            slug = this.route.data['value'].data[0].slug;
            this.menuService.setActiveLink(element.menuCat, slug);
          }
        )
      }
    });


    if (this.data.authService && this.data.authService.isLoggedIn()) {
      this.user = this.data.authService.getLoggedUser();
    }

    if (this.data.authService && this.data.authService.getUserData()) {
      this.userInfoSubscription = this.data.authService.getUserData().subscribe(res => {
        if (res) {
          this.user = res;
        }
      });
    }

    if (this.settings.nav_background_color) {
      this.settings.nav_background_color = this.settings.nav_background_color && this.settings.nav_background_color.charAt(0) === '#' ? this.settings.nav_background_color : this.getThemeColor(this.settings.nav_background_color);
    }
    if (this.settings.nav_background_color) {
      this.settings.nav_text_color = this.settings.nav_text_color && this.settings.nav_text_color.charAt(0) === '#' ? this.settings.nav_text_color : this.getThemeColor(this.settings.nav_text_color);
    }
  }

  // ngOnDestroy() {
  //   this.userInfoSubscription.unsubscribe();
  // }

  public getThemeColor(color) {
    if (this.data.moduleService && this.data.moduleService.theme && this.data.moduleService.theme.colors) {
      return this.data.moduleService.theme.colors[color];
    } else {
      return 'initial';
    }
  }

  public logOut() {
    this.user = this.data.authService.loggeOut();
    setTimeout(() => {
      if (this.settings.showlogoutRedirect && this.settings.LogoutRedirectPage) {
        location.href = this.settings.LogoutRedirectPage;
      } else {
        this.router.navigate(['/']);
      }
      location.reload();
    }, 1000);

  }

  public callActions(funcName, params?) {
    console.log('search funcName', funcName);
    console.log('search params', params);
    this[funcName](params);
  }

  public navigateToSection(el) {
    const elmnt = document.getElementById(el);
    elmnt.scrollIntoView();
  }

  public setJquryAndStyles() {
    $('#player').prop('muted', true);
    for (const element of this.settings.blocks) {
      if (element.box_shadow) {
        $('.bottom-gd').css('box-shadow', '7px 7px 10px 0 rgba(76, 110, 245, .1)');
      }
    }
    const settings = this.settings;
    $('ul.dropdown-menu.menu-' + settings.id + ' [data-toggle=\'dropdown\']').on('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      let directionLeft = false;
      let opend = 'opend';
      if ($(this).offset().left > 1000) {
        directionLeft = true;
        opend = 'opend-left';
      }

      if ($(this).hasClass(opend)) {
        $(this).removeClass(opend);
      } else {
        $(this).toggleClass(opend);
      }

      if (directionLeft) {
        if ($(this).siblings().hasClass('left')) {
          $(this).siblings().removeClass('left');
        }
        $(this).siblings().toggleClass('left');
      }
      $(this).siblings().toggleClass('show');
      $(this).siblings().toggleClass(opend);
      if (!$(this).next().hasClass('show')) {
        $(this).parents('.dropdown-menu.menu-' + settings.id).first().find('.show').removeClass('show');
        $(this).parents('.dropdown-menu.menu-' + settings.id).first().find('.left').removeClass('left');
        $(this).parents('.dropdown-menu.menu-' + settings.id).first().find('.' + opend).removeClass(opend);
      }
      $(this).parents('li.nav-item.dropdown.' + 'show').on('hidden.bs.dropdown', () => {
        $('.dropdown-submenu .show').removeClass('show');
        $('.dropdown-submenu .show.left').removeClass('left');
        $('.dropdown-submenu .' + opend).removeClass(opend);

      });

    });
    const nav = $('#nav-' + settings.id);
    if (settings.navcolorFrom === 'new') {
      nav.css('background', settings.nav_new_background_color);
      $('#nav-' + settings.id + ' a').css('color', settings.nav_new_text_color);
    }
  }

  public setBordersAndShadow() {
    const settings = this.settings;

    const submenu = $('#submenu-' + settings.id);
    if (this.settings.borderAll) {
      submenu.css('border', this.settings.bordersize + 'px ' + this.settings.borderType + ' ' + this.settings.bordercolor);
    } else {
      if (this.settings.borderTop) {
        submenu.css('border-top', this.settings.borderTop + 'px ' + this.settings.borderType + ' ' + this.settings.bordercolor);
      }
      if (this.settings.borderTop) {
        submenu.css('border-bottom', this.settings.borderBottom + 'px ' + this.settings.borderType + ' ' + this.settings.bordercolor);
      }
      if (this.settings.borderTop) {
        submenu.css('border-left', this.settings.borderLeft + 'px ' + this.settings.borderType + ' ' + this.settings.bordercolor);
      }
      if (this.settings.borderTop) {
        submenu.css('border-right', this.settings.borderRight + 'px ' + this.settings.borderType + ' ' + this.settings.bordercolor);
      }
    }

    submenu.css('box-shadow', this.settings.hoffset + 'px ' + this.settings.voffset + 'px ' + this.settings.blur + 'px ' + this.settings.spread + 'px ' + this.settings.boxcolor);

  }

  public GetCategoryMenus(id: number) {
    if (id) {
      if (this.data.dataChashingService && this.data.dataChashingService.menusCategories[id]) {
        this.menus = this.data.dataChashingService.menusCategories[id];
        this.data.SharedService.setCurrentMenu(id);
        setTimeout(() => {
          this.setJquryAndStyles();
        }, 500);
      } else {
        this.essentialsService.getCategoryMenus(id).subscribe((res: any) => {
          this.data.dataChashingService.menusCategories[id] = res;
          this.menus = res;
          this.sortMenu(this.menus);
          this.data.SharedService.setCurrentMenu(id);
          setTimeout(() => {
            this.setJquryAndStyles();
          }, 500);
        });
      }
    } else {

    }
  }

  public sortMenu(menuItems) {
    menuItems.sort((a, b) => {
      return a.order - b.order;
    });
    menuItems.forEach((element) => {
      if (element.childs.length > 1) {
        this.sortMenu(element.childs);
      }
    });
  }

  public GetAllPages() {
    if (this.data.dataChashingService && this.data.dataChashingService.pagesList) {
      this.allPages = this.data.dataChashingService.pagesList;
    } else if (this.data.moduleService && this.data.moduleService.siteSlugs) {
      this.allPages = this.data.moduleService.siteSlugs;
      this.data.dataChashingService.pagesList = this.data.moduleService.siteSlugs;
    }
  }

  public getPageSlug(id) {
    const slug = this.allPages.find((s) => s.id === id);
    return slug ? '/' + slug.slug : this.allPages[0] ? this.allPages[0].slug : null;
  }


  public navigateToPage() {
    this.settings.blocks.forEach(element => {
      if (element.element.type == 'Button') {
        let link = this.getPageSlug(element.pageId);
        this.router.navigate([link]);
        if (this.settings.divId) {
          setTimeout(() => {
            this.navigateToSection(element.divId)
          }, 200);
        }
      }
    });

  }


  public getCultureLinkedBlog(id, culture) {
    const currentPage = this.data.dataChashingService.blogs[id]
    if (currentPage.addtionalMetaTags && currentPage.addtionalMetaTags != null) {
      let temp = JSON.parse(currentPage.addtionalMetaTags)
      for (let i = 0; i < temp.length; i++) {
        const element = temp[i];
        if (element.property == culture) {
          return this.setNewRoute(this.settings.prefix || '', element.content)
        }
      }
    }
    return '/';
  }


  public setNewRoute(prefix, newRoute) {
    this.router.config = [];
    this.data.moduleService.site.HostName = prefix.replace("/", '');
    this.data.routerService.getRoute();
    return '/' + prefix + newRoute
  }


  public setsiteCss(Culture,oldCulture) {
    let css = JSON.parse(this.data.moduleService.site.css);
    const head = document.getElementsByTagName('head')[0];
    if (css[Culture]) {
      const oldCss = document.getElementsByTagName('style');
      for (let index = 0; index < oldCss.length; index++) {
        const element = oldCss[index];
        if (element.id.indexOf(oldCulture + '-style') !== -1) {
          head.removeChild(element);
          index = index - 1;
        }
      }
      const culture_css = document.createElement('style');
      culture_css.type = 'text/css';
      culture_css.id = Culture + '-style';
      culture_css.appendChild(document.createTextNode(css[this.settings.Culture]));
      head.appendChild(culture_css);
    }
  }


  public getCultureLinkedPage(id, culture) {
    this.settings.blocks.forEach(element => {
      if (element.element.type == 'Button') {
        const currentPage = this.data.dataChashingService.pages[id]
        if (currentPage.addtionalMetaTags && currentPage.addtionalMetaTags != null) {
          let temp = JSON.parse(currentPage.addtionalMetaTags)
          for (let i = 0; i < temp.length; i++) {
            const element = temp[i];
            if (element.property == culture) {
              return this.setNewRoute(this.settings.prefix || '', element.content)
            }
          }
        }
      }
    });

    return '/';
  }


  public navigateToCulture() {
    let link = ''
    if (this.route.data['value'].type == 1)
      link = this.getCultureLinkedPage(this.route.data['value'].id, this.settings.Culture);
    else
      link = this.getCultureLinkedBlog(this.route.data['value'].id, this.settings.Culture);

    if (link != '/' && this.data.moduleService.site.css) {
      const oldCulture = this.data.moduleService.site.culture;
      this.data.moduleService.site.culture = this.settings.Culture;
      this.router.navigate([link]);
      this.setsiteCss(this.settings.Culture,oldCulture)
    }

  }

}
